import max from 'lodash-es/max';
import Flickity from 'react-flickity-component';
import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import ProductTileAlternate from '../../components/React/ProductTileAlternate.jsx';

let fallBackTimer;

const FeaturedCarousel = (props) => {
  const [items, setItems] = useState([]);
  const [variantAvailabilities, setVariantAvailabilities] = useState([]);
  const flickity = useRef(null);

  const carouselOptions = {
    imagesLoaded: true,
    cellAlign: 'center',
    contain: false,
    groupCells: false,
    draggable: true,
    wrapAround: true,
    dragThreshold: 10,
    initialIndex: 0,
  };

  useEffect(() => {
    console.log('inside fertured');
  }, []);

  return (
    <div className="FeaturedCarousel__component">
      <Flickity className="SliderCartAddons" options={carouselOptions} reloadOnUpdate={true} ref={flickity}>
        {items.map((item, i) => {
          const firstVariant = item.Child_Attributes[0];
          const comparePrices = item.Child_Attributes.map((variant) => {
            return variant.compare_at_price;
          });
          const comparePriceMax = max(comparePrices);

          if (!firstVariant) {
            return null;
          }

          const variantsWithAvailability = item.Child_Attributes.map((variant) => {
            const available = variantAvailabilities[variant.variant_id]
              ? variantAvailabilities[variant.variant_id]
              : false;

            return {
              ...variant,
              available,
            };
          });

          const productUrl = item.Detail_URL.replace('https://windsor-us.myshopify.com', '');

          return (
            <ProductTileAlternate
              key={`TrendingCarousel__ProductTile-${item.ID}-${i}`}
              id={item.product_id}
              pid={item.ID}
              title={item.Title}
              product_url={productUrl}
              thumb_url={firstVariant.image_url}
              thumb_alt={item.Title}
              price={firstVariant.price}
              price_compare={firstVariant.compare_at_price}
              price_compare_max={comparePriceMax}
              tags={item.tags.split(',')}
              variants={variantsWithAvailability}
              product={item}
              options={item.options}
              colorOptions={item.color}
              sizeOptions={item.size}
              isRec={true}
              selectedColor={item.selectedColor}
            />
          );
        })}
      </Flickity>
    </div>
  );
};

export default () => {
  document.querySelectorAll('[data-featured-carousel]').forEach((el) => {
    if (el.getAttribute('initialized') === 'true') {
      return;
    }

    const scheme = el.getAttribute('data-scheme');

    ReactDOM.render(React.createElement(FeaturedCarousel, { scheme }), el);

    el.setAttribute('initialized', 'true');
  });
};
